import React, { Component, Fragment } from 'react';
import withTranslations from '../../translations';
import { withStyles, withWidth } from '@material-ui/core';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  clearJobs,
  getJobsFromSAP,
  getJobsWithSameSerialNumber,
  importJob,
  linkJob,
} from '../../actions/importJob';

import {
  AlertDialog,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Loader,
} from '../../components/base';

import {
  columns,
  smallScreens,
} from './constants.js';

import SubHeader from '../../components/SubHeader/SubHeader';

import { rootUrl } from '../../constants/urls';

import { permissions } from '../../constants/permissions';

import { userHasPermission } from '../../utils/permissions';
import { removeLeadingZeros } from '../../utils/utils';

import {
  headerHeight,
  subHeaderHeight,
} from '../../constants/styles';

const styles = theme => ({
  container: {
    margin: `${headerHeight + subHeaderHeight + theme.spacing(4)}px ${theme.spacing()}px ${theme.spacing()}px`,
    padding: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      margin: `${headerHeight + subHeaderHeight + theme.spacing(6)}px ${theme.spacing(4)}px ${theme.spacing(4)}px`,
      padding: `${theme.spacing(3)}px ${theme.spacing(3)}px`,
    },
  },
  formContainer: {
    marginBottom: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: theme.spacing(2),
    },
  },
  field: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: '33%',
    },
  },
  searchButton: {
    color: theme.palette.primary.main,
    marginTop: theme.spacing(4),

    [theme.breakpoints.up('sm')]: {
      marginTop: 0,
    },
  },
  table: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    marginBottom: theme.spacing(6),

    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(4),
    },
  },
  tableHeader: {
    background: theme.palette.secondary.main,

    '& th': {
      color: theme.palette.primary.main,
    }
  },
  selectedRow: {
    background: theme.palette.background.default,
    border: `2px solid ${theme.palette.secondary.main}`
  },
  selectedRowMobile: {
    border: `2px solid ${theme.palette.secondary.main}`,
  },
  mobileJobContainer: {
    margin: theme.spacing(),
    padding: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      margin: `${theme.spacing(2)}px ${theme.spacing(4)}px`,
    },
  },
  mobileJobRow: {
    marginBottom: theme.spacing(),

  },
  noResultsContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(4),
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'white',
  },
  loader: {
    marginBottom: theme.spacing(),
  },
});

class ImportJobView extends Component {
  state = {
    notificationNumber: '',
    serviceOrderNumber: '',
    currentSearch: {},
    selectedJob: {},
    selectedRow: '',
    isSearched: false,
    linkJobDialog: false,
    jobsToLink: null,
    jobToLink: null,
    importingInProgress: false,
  };

  componentWillUnmount() {
    this.props.actions.clearJobs();
  }

  handleInput = key => e => this.setState({[key]: e.target.value.replace(/^0+/, '').trim()});

  nullifySapSerialNumber = serialNumber =>
    serialNumber === '' || serialNumber === 'NULL' || serialNumber === ' ' || serialNumber === null
      ? null
      : serialNumber;

  handleSelectJob = ({ notificationNumber, serviceOrderNumber, sourceId, serialNumber }) =>
    this.setState({
      selectedJob: {
        notificationNumber,
        serviceOrderNumber,
        sourceId,
        serialNumber: this.nullifySapSerialNumber(serialNumber),
      },
      selectedRow: sourceId + notificationNumber + serviceOrderNumber,
    });

  getSearchObj = () => {
    const { notificationNumber, serviceOrderNumber } = this.state;
    let searchObj = {};

    if (notificationNumber.length >= 5) searchObj = {...searchObj, notificationNumber}
    if (serviceOrderNumber.length >= 5) searchObj = {...searchObj, serviceOrderNumber}

    return searchObj;
  }

  getJobsFromSAP = async () => {
    const searchObj = this.getSearchObj();

    if (Object.keys(searchObj).length) {
      await this.props.actions.getJobsFromSAP(searchObj);

      this.setState({
        currentSearch: searchObj,
        isSearched: true,
        selectedJob: {},
        selectedRow: '',
      })
    }
  }

  handleRadioSelect = e => this.setState({jobToLink: e.target.value})

  handleLinkJobConfirm  = async () => {
    const { selectedJob, currentSearch, jobToLink } = this.state;

    this.setState({ importingInProgress: true });

    if (jobToLink === 'import') {
      Object.keys(currentSearch).length
      ? await this.props.actions.importJob(selectedJob, currentSearch)
      : await this.props.actions.importJob(selectedJob);
    } else {
      await this.props.actions.linkJob(jobToLink, selectedJob, currentSearch);
    }

    this.setState({ linkJobDialog: false, selectedJob: {}, jobToLink: null, importingInProgress: false });
  }

  renderLinkJobDialog = (c, t, gt, jobs) =>
    <AlertDialog
      open={this.state.linkJobDialog}
      title={t.openJobsFoundForSerNumber}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.proceed}
      confirmDisabled={!this.state.jobToLink}
      handleCancel={() => this.setState({ linkJobDialog: false, selectedJob: {}, jobToLink: null })}
      handleConfirm={() => this.handleLinkJobConfirm()}
    >
      <FormControl>
        <RadioGroup
          aria-label="open_jobs_found_for_this_serial_number"
          name="open jobs found for this serial number"
          onChange={this.handleRadioSelect}
          value={this.state.jobToLink || ''}
          className={classNames(c.radioOptions, 'block')}
        >
          <FormControlLabel
            key='import'
            value='import'
            control={<Radio />}
            label={t.importJobAsNew}
          />
          {jobs && jobs.map(job =>
            <FormControlLabel
              key={job.jobId}
              value={`${job.jobId}`}
              control={<Radio />}
              label={`${t.linkTo} ${t.columns.notificationNumber}: ${removeLeadingZeros(job.notificationNumber)} ${t.columns.serviceOrderNumber}: ${removeLeadingZeros(job.serviceOrderNumber)} ${t.columns.sourceId}: ${job.sourceId}`}
            />
          )}
          {
            this.state.importingInProgress &&
            <div className={c.loadingOverlay}>
              <Loader className={c.loader} color='secondary' />
              <Typography variant='caption'>{t.linking}</Typography>
            </div>
          }
        </RadioGroup>
      </FormControl>
    </AlertDialog>

  importJob = async () => {
    this.setState({ importingInProgress: true, isLoading: true });
    const { selectedJob, currentSearch } = this.state;
    const existingJobsWithSameSerNum = await this.props.actions.getJobsWithSameSerialNumber(selectedJob.serialNumber);

    if (existingJobsWithSameSerNum.length) {
      this.setState({ linkJobDialog: true, jobsToLink: existingJobsWithSameSerNum, selectedJob, importingInProgress: false, isLoading: false });
    } else {
      Object.keys(currentSearch).length
      ? await this.props.actions.importJob(selectedJob, currentSearch)
      : await this.props.actions.importJob(selectedJob);

      this.setState({ selectedJob: {}, importingInProgress: false, isLoading: false });
    }
  }

  renderDesktopView = () => {
    const { classes: c, gt, t, jobs } = this.props;
    const { selectedRow } = this.state;
    const uniqueJobId = job => job.sourceId + job.notificationNumber + job.serviceOrderNumber;

    return (
      <Paper className={c.table}>
        <Table>
          <TableHead className={c.tableHeader}>
            <TableRow>
              {columns(t.columns).map(column => (
                <TableCell key={column.label}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {jobs.map(job => (
              <TableRow
                hover
                key={uniqueJobId(job)}
                onClick={() => this.handleSelectJob(job)}
                className={uniqueJobId(job) === selectedRow ? c.selectedRow : ''}
                style={{cursor: 'pointer'}}
              >
                <TableCell>{job.sourceId}</TableCell>
                <TableCell>{removeLeadingZeros(job.notificationNumber)}</TableCell>
                <TableCell>{removeLeadingZeros(job.serviceOrderNumber)}</TableCell>
                <TableCell>
                  {
                    job.serialNumber && job.serialNumber !== 'NULL' && job.serialNumber !== ' '
                      ? removeLeadingZeros(job.serialNumber)
                      : <Typography color='error'>{gt.serialNumberMissing}</Typography>
                  }
                </TableCell>
                <TableCell>{job.jobTypeDescription}</TableCell>
                <TableCell>{job.customerName}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    );
  }

  renderMobileView = () => {
    const { classes: c, gt, t, jobs } = this.props;
    const { selectedRow } = this.state;
    const uniqueJobId = job => job.sourceId + job.notificationNumber + job.serviceOrderNumber;
    const selectedRowClass = job => uniqueJobId(job) === selectedRow ? c.selectedRowMobile : '';

    return (
      jobs.map(job =>
        <Paper component='main'
          key={uniqueJobId(job)}
          className={classNames(c.mobileJobContainer, selectedRowClass(job))}
        >
          {columns(t.columns).map(column =>
            <Grid container
              className={c.mobileJobRow}
              key={column.value}
              onClick={() => this.handleSelectJob(job)}
            >
              <Grid
                item xs={5}
              >
                <i>{column.label}</i>
              </Grid>
              <Grid
                item xs={7}
              >
                {
                  column.value === 'serialNumber'
                    ? job[column.value] && job[column.value] !== 'NULL' && job[column.value] !== ' ' ? removeLeadingZeros(job[column.value]) : gt.serialNumberMissing
                    : removeLeadingZeros(job[column.value])
                }
              </Grid>
            </Grid>
          )}
        </Paper>
      )
    );
  }

  render() {
    const { classes: c, gt, t, user, jobs, width, message } = this.props;
    const { notificationNumber, serviceOrderNumber, selectedJob, isSearched, jobsToLink } = this.state;

    return (
      <Fragment>
        <SubHeader
          view='importJob'
          translations={{ title: t.title, createdAt: t.date, actionButton: t.importButton, }}
          actionButton={{
            disabled: !Object.keys(selectedJob).length || this.state.importingInProgress,
            condition: userHasPermission(user, permissions.IMPORT_JOB_FROM_SAP),
            onActionClick: this.importJob,
          }}
          cancelButton={{route: rootUrl()}}
        />

        <Paper component='main' className={c.container} >
          <div>
            <Typography variant='h6'>{t.searchTitle}</Typography>
            <Typography variant='caption'>{t.searchSubtitle}</Typography>
            <div className={c.formContainer}>
              <TextField
                fullWidth
                className={c.field}
                type='text'
                label={t.notificationNumberLabel}
                onChange={this.handleInput('notificationNumber')}
                value={notificationNumber}
              />
              <TextField
                fullWidth
                className={c.field}
                type='text'
                label={t.serviceOrderNumberLabel}
                onChange={this.handleInput('serviceOrderNumber')}
                value={serviceOrderNumber}
              />
              <Button
                className={c.searchButton}
                variant='contained'
                color='secondary'
                onClick={this.getJobsFromSAP}
                disabled={notificationNumber.length < 5 && serviceOrderNumber.length < 5}
              >
                {t.searchButton}
              </Button>
            </div>
          </div>
        </Paper>

        {jobs && jobs.length
          ? smallScreens.includes(width) ? this.renderMobileView() : this.renderDesktopView()
          : isSearched
            ? <div className={c.noResultsContainer}>{message === 'No results' ? gt.noResults : t.jobIsImportedAlready}</div>
            : null
        }
        { this.state.importingInProgress &&
          <div className={c.loadingOverlay}>
            <Loader className={c.loader} color='secondary' />
            <Typography variant='caption'>{t.importing}</Typography>
          </div>
        }
        {this.renderLinkJobDialog(c, t, gt, jobsToLink)}
      </Fragment>
    );
  }
};

const mapStateToProps = state => ({
  jobs: state.importJobs.jobs.jobs,
  message: state.importJobs.jobs.message,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getJobsFromSAP: bindActionCreators(getJobsFromSAP, dispatch),
    importJob: bindActionCreators(importJob, dispatch),
    getJobsWithSameSerialNumber: bindActionCreators(getJobsWithSameSerialNumber, dispatch),
    linkJob: bindActionCreators(linkJob, dispatch),
    clearJobs: bindActionCreators(clearJobs, dispatch),
  }
})

export default withWidth()(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(withTranslations(ImportJobView, 'ImportJob'))));



// WEBPACK FOOTER //
// ./src/views/ImportJob/ImportJobView.js